"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sleep = exports.MomentTimezoneMap = exports.TimezoneMapOptions = exports.TimezoneMomentMap = exports.TimezoneMap = void 0;
exports.TimezoneMap = {
    '-1100': 'Pacific/Midway',
    '-1000': 'US/Hawaii',
    '-930': 'Pacific/Marquesas',
    '-900': 'US/Alaska',
    '-800': 'Canada/Pacific',
    '-700': 'US/Arizona',
    '-600': 'America/Mexico City',
    '-500': 'America/Havana',
    '-400': 'Atlantic/Bermuda',
    '-330': 'Canada/Newfoundland',
    '-300': 'America/Montevideo',
    '-200': 'America/Noronha',
    '-100': 'Cape Verde',
    0: 'Coordinated Universal Time, London, Dublin',
    100: 'Amsterdam, Berlin, Rome, Stockholm',
    200: 'Athens, Bucharest, Amman, Beirut',
    300: 'Istanbul, Baghdad, Kuwait, Riyadh',
    330: 'Tehran',
    400: 'Dubai, Abu Dhabi, Muscat, Baku, Tbilisi',
    430: 'Kabul',
    500: 'Ashgabat, Islamabad, Karachi',
    530: 'Chennai, Kolkata, Mumbai, New Delhi',
    545: 'Kathmandu',
    600: 'Astana, Dhaka',
    630: 'Yangon',
    700: 'Bangkok, Hanoi, Jakarta',
    800: 'Hong Kong, Peking',
    900: 'Tokyo, Pyongyang',
    1000: 'Canberra, Brisbane, Sydney, Melbourne',
    1030: 'Adelaide',
    1100: 'Vladivostok, Magadan',
    1200: 'Magadan, Nauru, Fiji',
};
exports.TimezoneMomentMap = {
    '-1100': 'Pacific/Midway',
    '-1000': 'US/Hawaii',
    '-930': 'Pacific/Marquesas',
    '-900': 'US/Alaska',
    '-800': 'Canada/Pacific',
    '-700': 'US/Arizona',
    '-600': 'America/Mexico City',
    '-500': 'America/Havana',
    '-400': 'Atlantic/Bermuda',
    '-330': 'Canada/Newfoundland',
    '-300': 'America/Montevideo',
    '-200': 'America/Noronha',
    '-100': 'Cape Verde',
    0: 'Europe/London',
    100: 'Europe/Stockholm',
    200: 'Europe/Athens',
    300: 'Asia/Baghdad',
    330: 'Asia/Tehran',
    400: 'Asia/Baku',
    430: 'Asia/Kabul',
    500: 'Asia/Tashkent',
    530: 'Asia/Kolkata',
    545: 'Asia/Kathmandu',
    600: 'Asia/Dhaka',
    630: 'Asia/Yangon',
    700: 'Asia/Bangkok',
    800: 'Asia/Hong_Kong',
    900: 'Asia/Tokyo',
    1000: 'Australia/Melbourne',
    1030: 'Australia/Adelaide',
    1100: 'Asia/Vladivostok',
    1200: 'Asia/Magadan',
};
exports.TimezoneMapOptions = Object.entries(exports.TimezoneMap).sort((a, b) => +b[0] - +a[0]).map(([key, title,]) => {
    const num_key = +key;
    const str_key = key + '';
    let display_zone = num_key ? `${str_key.substr(0, str_key.length - 2)}:${str_key.substr(str_key.length - 2, 2)}` : '';
    if (display_zone.length === 4)
        display_zone = `0${display_zone}`;
    if (num_key)
        display_zone = `${num_key < 0 ? '-' : '+'}${display_zone}`;
    return {
        key: +key,
        title: `(UTC${display_zone ? ` ${display_zone}` : ''}) ${title}`,
    };
});
exports.MomentTimezoneMap = {
    '-1100': 'Pacific/Midway',
    '-1000': 'US/Hawaii',
    '-930': 'Pacific/Marquesas',
    '-900': 'US/Alaska',
    '-800': 'Canada/Pacific',
    '-700': 'US/Arizona',
    '-600': 'America/Mexico_City',
    '-500': 'America/Havana',
    '-400': 'Atlantic/Bermuda',
    '-330': 'Canada/Newfoundland',
    '-300': 'America/Montevideo',
    '-200': 'America/Noronha',
    '-100': 'Atlantic/Cape_Verde',
    0: 'Europe/London',
    100: 'Europe/Stockholm',
    200: 'Europe/Athens',
    300: 'Asia/Istanbul',
    330: 'Asia/Tehran',
    400: 'Asia/Baku',
    430: 'Asia/Kabul',
    500: 'Asia/Karachi',
    530: 'Asia/Kolkata',
    545: 'Asia/Katmandu',
    600: 'Asia/Dacca',
    630: 'Asia/Yangon',
    700: 'Asia/Bangkok',
    800: 'Asia/Hong_Kong',
    900: 'Asia/Tokyo',
    1000: 'Australia/Brisbane',
    1030: 'Australia/Adelaide',
    1100: 'Asia/Magadan',
    1200: 'Pacific/Nauru',
    1300: 'Pacific/Auckland',
    1400: 'Pacific/Kiritimati',
};
const Sleep = (seconds) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true);
        }, seconds * 1000);
    });
};
exports.Sleep = Sleep;
